import { clientFetch } from '../clientFetch';

export const getConditionBySlug = async (slug) => clientFetch(`/lookup/condition/${slug}`).then((r) => r.result);
